import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router';
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";

import Select from 'react-select';

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: '0 6px',
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: '#e0f2ff',
    borderRadius: '4px',
  }),
};
interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
}
interface pointstruc{
  id:number;
  type:string;
  data:number
}

interface DataStructure {
  id: number;
  slug: string;
  name: string;
}

const News = () => {
  const api = process.env.REACT_APP_API_URL as string;



// console.log('attendance point data here.. ',attendancePoint);
    const [searchNotFound, setSearchNotFound] = useState<string>('');
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const[NewPopup,setNewsPopup] = useState(false);

  const [usersData, setUsersData] = useState([]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async () => {
    
    //console.log('Searching for:', searchQuery);
  
    try {
      // Make sure the searchQuery is not empty before making the request
      if (!searchQuery) {
        alert('Please enter a search term');
        return;
      }
  
      // Sending a GET request to the backend with the search query
      const response = await axios.get(`${api}/auth/news/search/${searchQuery}`);
      //console.log('news data',response.data)
      setNewData(response.data);
      
      // Log the response data for debugging
      //console.log('Search results:', response.data);
      setSearchNotFound('');
      // Handle the data (e.g., updating state, displaying results)
      // For example, you could update the state here
      // setSearchResults(response.data);
  
    } catch (error) {
      setSearchNotFound('Not Found')
      console.error('Error during search:', error);
    }
  };
  

  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };

  const closeNewspop =()=>{
    setNewsPopup(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news`
        );

        //console.log('news data',response.data)
        setNewData(response.data);
        //console.log("news data in a array",newData);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/inserdata`
        );

        //console.log('media data inserted',response.data)
        setNewData(response.data);
        //console.log("media data in a array",newData);
      } catch (error) {
        console.error("media data Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const response = await axios.get(
          `${api}/auth/allusersinfo`
        );
  
        //console.log("All users data:", response.data);
        setUsersData(response.data); // Set users data
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
  
    fetchAllUserData();
  }, []);

  function deletePost(id: string): void {
    const confirmation = window.confirm('Are you sure you want to delete this post?');
    
    if (confirmation) {
      axios
        .delete(`${api}/auth/news/${id}`)
        .then((response) => {
          // Handle the success case
          alert('Post deleted successfully');
          //console.log(response.data); // Log the response or update your state/UI
          window.location.reload();
        })
        .catch((error) => {
          // Handle errors
          console.error('Error deleting post:', error);
          alert('Failed to delete the post. Please try again.');
        });
    }
  }

  
 
  return (
    <div>
         {/* news header  */}
         <div
  className="flex flex-wrap justify-between items-center sticky top-0 z-10 px-4 sm:px-8 md:px-12 w-full left-0 right-0 lg:h-[74px] h-[150px] "
  style={{
    WebkitBackdropFilter: 'blur(22px)',
    backdropFilter: 'blur(22px)',
  }}
>
  {/* Add Event Button */}
  <div
    className="flex items-center cursor-pointer h-[40px] md:h-[45px] px-2 py-1 md:py-2 bg-[#FDBC12] text-darkblue rounded-lg gap-2 mb-2 sm:mb-0"
    onClick={() => openModal('')}
  >
    <BsPlusCircleFill /> <h6 className="text-sm md:text-base">Add Event</h6>
  </div>



  {/* Search Input */}
  <div className="w-full sm:w-auto flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
    <div className="bg-transparent border h-[40px] md:h-[45px] border-darkblue px-2 rounded-lg flex items-center w-full sm:w-auto">
      <input
        type="search"
        name="search"
        className="placeholder-darkblue border-none outline-none bg-transparent flex-grow text-sm md:text-base"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Write here..."
      />
      <button
        className="cursor-pointer px-2 border-l border-darkblue h-full flex items-center justify-center text-sm md:text-base"
        onClick={handleSearch}
      >
        Search
      </button>
    </div>
    {searchNotFound && (
      <p className="text-red-500 text-sm md:text-base mt-1 sm:mt-0">{searchNotFound}</p>
    )}
  </div>
</div>


         <div>
         {NewPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <ModalNews  onCloseNewsPop={closeNewspop} />
          </div>
        </div>
      )}

         {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal users={usersData} postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
{newData.length > 0 ? (
     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 lg:p-12 p-3">
          {newData.map((item) => (
            <div className='bg-white rounded-lg p-2 drop-shadow-md'>
              <img
      className="h-[250px] object-contain w-full max-w-full rounded-lg"
      src={
        item.img
          ? item.img.startsWith("http")
            ? item.img // Use the full URL if already valid
            : `${api}/${item.img}` // Prepend base URL for relative paths
          : "https://via.placeholder.com/150" // Placeholder image for missing URLs
      }
      alt={item.title || "Image"}
    />
               
               <h3 className='font-semibold text-lg py-4 '>{item.title}</h3>
               <div className='flex justify-between gap-4'> 
                
                <div className='flex w-[130px] justify-center cursor-pointer   py-2 border border-darkblue  text-darkblue items-center rounded-lg gap-2' onClick={() => openModal(item.id)}>
             <CiEdit/>  <h6>Edit Event</h6>
            </div>
            
                <div className='flex  w-[130px] justify-center cursor-pointer   py-2 border border-red-600 text-red-600 items-center rounded-lg gap-2' onClick={() => deletePost(item.id)}>
             <RiDeleteBin5Line/>  <h6>Delete Event</h6>
            </div>

            </div>
               
            </div>
          ))}
       </div>
      ) : (
        <p>Loading...</p>
      )}
         </div>
          
        
    </div>
  )
}

interface ModalProps {
  postId?: string | null; 
  onClose: () => void;
  users: { id: number; name: string;}[]; 
}

const Modal: React.FC<ModalProps> = ({ users, postId, onClose }) => {
  

   const categories = ['Politics', 'Technology', 'Health', 'Business', 'Sports'];
  const tags = ['Breaking', 'World', 'Trending', 'Exclusive', 'Editorial'];
  const[catdata, setCatdata] = useState<DataStructure[]>([]);
  const[tagdata, settagdata] = useState<DataStructure[]>([]);
  const [fileList, setFileList] = useState<File[]>([]);
  const api = process.env.REACT_APP_API_URL as string;


   useEffect(() => {
  const fetchTags = async () => {
    try {
      const res = await axios.get<DataStructure[]>(`${api}/auth/category`);
      setCatdata(res.data as []);
    } catch (err) {
      console.error('Error fetching tags:', err);
    }
  };

  fetchTags();
}, []);

  useEffect(() => {
  const fetchTags = async () => {
    try {
      const res = await axios.get<DataStructure[]>(`${api}/auth/tags`);
      settagdata(res.data as []);
    } catch (err) {
      console.error('Error fetching tags:', err);
    }
  };

  fetchTags();
}, []);



  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
  
    // Ensure it's in Asia/Kolkata timezone and formatted correctly
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata', // Adjust for the correct timezone
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
      .format(date)
      .split("/")
      .reverse()
      .join("-"); // Convert "DD/MM/YYYY" -> "YYYY-MM-DD"
  };
  
  
  
  
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    date: '',
    image: null as File | null,
    Gallery:'',
   tags: [] as string[],
  category: [] as string[],
    author: '',
  



  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

useEffect(() => {
  if (!postId) return;

  const fetchPost = async () => {
    try {
      const res = await axios.get(`${api}/auth/news/${postId}`);
      const data = Array.isArray(res.data) ? res.data[0] : res.data;

      const { title, content, date, img, Gallery = '', tags = '', category = '', author = '' } = data;

      setFormData({
        title,
        content,
        date: formatDate(date),
        image: null, // Set later below
        Gallery,
        tags: tags.split('&'),
        category: category.split('&'),
        author,
      });

      if (img) {
  setFileName(img); // Save the image path (e.g. "uploads/image_123.png")
  setFormData(prev => ({
    ...prev,
    image: null // Keep image as null to avoid treating it as a new file
  }));
}


      const galleryArray = Gallery.split('&').filter(Boolean);
      if (galleryArray.length > 0) {
        const galleryFiles = await Promise.all(
          galleryArray.map(async (imgPath:any) => {
            const res = await fetch(`/${imgPath}`);
            const blob = await res.blob();
            const fileName = imgPath.split('/').pop() || 'gallery.jpg';
            return new File([blob], fileName, { type: blob.type });
          })
        );
        setFileList(galleryFiles);
      }

    } catch (err) {
      console.error('Error fetching post:', err);
    }
  };

  fetchPost();
}, [postId]);



  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleAttendeesChange = (selectedOptions: any) => {
    // Extract selected user IDs from the react-select
    const selectedIds = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];

    setFormData((prev) => ({ ...prev, attendees: selectedIds }));

  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  
    
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);

    
     // handling multiple file
     
  };

  
  const handlegalleryChange = (e: React.ChangeEvent<HTMLInputElement>) => {

     // handling multiple file
     const files = e.target.files;
     //console.log("file from here...", files?.length)
    if (files) {
      setFileList(Array.from(files)); // Convert FileList to Array and set state
      
    }
    //console.log(fileList);
  };

  // Handle checkbox change (update status)
const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target;

    setFormData((prev) => {
      const prevList = prev[name as keyof typeof prev] as string[];
      const updatedList = checked
        ? [...prevList, value]
        : prevList.filter((item) => item !== value);

      return {
        ...prev,
        [name]: updatedList,
      };
    });
  };



 const handleSubmit2 = async (e: React.FormEvent) => {
  e.preventDefault();

   console.log('formData.title ',formData.title, 'formData.content ', formData.content, 'formData.date ', formData.date, 'formData.author ', formData.author, 'formData.tags.length', formData.tags.length, 'formData.image ', formData.image)
  // Validate required fields
  if (
    !formData.title ||
    !formData.content ||
    !formData.date ||
    !formData.author ||
    !formData.tags.length ||
    !formData.image
  ) {
    setError('All fields are required.');
    return;
  }

  const data = new FormData();
  data.append('title', formData.title);
  data.append('content', formData.content);
  data.append('date', formData.date);
  data.append('author', formData.author);

  // Image
  if (formData.image) {
    data.append('image', formData.image);
  } else if (fileName) {
  const response = await fetch(`/${fileName}`);
  const blob = await response.blob();
  const fallbackFile = new File([blob], fileName.split('/').pop() || 'image.jpg', {
    type: blob.type,
  });
  data.append('image', fileName);
  // data.append('image', fallbackFile); // ✅ Now multer can process it
}


  // Tags and category
  formData.tags.forEach((tag) => data.append('tags', tag));
  formData.category.forEach((cat) => data.append('category', cat));

 
  fileList.forEach((file) => {
    data.append('images', file); // Append each gallery image
  });

  try {
    if (postId) {
      await axios.put(`${api}/auth/news/${postId}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } else {
      await axios.post(`${api}/auth/news`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    onClose();
    window.location.reload();
  } catch (err) {
    console.error('Error submitting post:', err);
    setError('Failed to submit the post. Please try again.');
  }
};
const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!formData.title || !formData.content || !formData.date || !formData.author || !formData.tags.length) {
    setError('All fields are required.');
    return;
  }

  const data = new FormData();
  data.append('title', formData.title);
  data.append('content', formData.content);
  data.append('date', formData.date);
  data.append('author', formData.author);

  formData.tags.forEach(tag => data.append('tags', tag));
  formData.category.forEach(cat => data.append('category', cat));
  fileList.forEach(file => data.append('images', file));

  if (formData.image instanceof File) {
    data.append('image', formData.image);
   
  } else if (fileName) {
    
    data.append('image', fileName);
    data.append('existingImage', fileName);
  }

  try {
    if (postId) {
      await axios.put(`${api}/auth/news/${postId}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } else {
      await axios.post(`${api}/auth/news`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    onClose();
    window.location.reload();
  } catch (err) {
    console.error('Error submitting post:', err);
    setError('Failed to submit the post. Please try again.');
  }
};


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white lg:w-1/2 md:w-[75%]  w-[96%] p-6 rounded shadow relative h-[670px] overflow-y-auto">
        
       <form onSubmit={handleSubmit} className="space-y-4">

      {/* Title */}
      <div>
        <label className="text-[#030303] font-medium">Post title</label>
        <div className="mt-1 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg flex items-center mb-4">
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Write your post title here..."
            className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
            required
          />
        </div>
      </div>

      {/* Author */}
      <div>
        <label className="text-[#030303] font-medium">Author</label>
        <input
          type="text"
          name="author"
          value={formData.author}
          onChange={handleChange}
          placeholder="Enter author name..."
          className="mt-1 mb-4 w-full h-[50px] border px-2 border-[#94A2B8] rounded-lg outline-none text-[14px]"
        />
      </div>

     <div>
        <h3 className="text-lg font-semibold mb-2 text-gray-700">Select Categories</h3>
        <div className="grid grid-cols-2 gap-2">
          {catdata.map((item) => (
            <label key={item.name} className="flex items-center space-x-2">
              <input
                type="checkbox"
                name="category"
                value={item.slug}
                checked={formData.category.includes(item.name)}
                onChange={handleCheckboxChange}
                className="accent-blue-600 w-4 h-4"
              />
              <span className="text-sm text-gray-800">{item.name}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Tags Multi-select */}
      <div>
        <h3 className="text-lg font-semibold mb-2 text-gray-700">Select Tags</h3>
        <div className="grid grid-cols-2 gap-2">
          {tagdata.map((item) => (
            <label key={item.name} className="flex items-center space-x-2">
              <input
                type="checkbox"
                name="tags"
                value={item.name}
                checked={formData.tags.includes(item.name)}
                onChange={handleCheckboxChange}
                className="accent-green-600 w-4 h-4"
              />
              <span className="text-sm text-gray-800">{item.name}</span>
            </label>
          ))}
        </div>
      </div>


      {/* Content */}
      <div>
        <label className="text-[#030303] font-medium">Description</label>
        <textarea
          name="content"
          value={formData.content}
          onChange={handleChange}
          className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
          placeholder="Write your message here..."
          rows={4}
          required
        />
      </div>

      {/* Gallery Upload */}
      <div>
        <label className="text-[#030303] font-medium">Add Gallery</label>
        <div className="mt-1 w-full h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
          <RiGalleryUploadLine
            size={24}
            className="text-[30px] cursor-pointer"
            onClick={() => document.getElementById("gallery-image-upload")?.click()}
          />
          <input
            id="gallery-image-upload"
            type="file"
            accept="image/*"
            name="images"
            className="hidden"
            multiple
            onChange={handlegalleryChange}
          />
          {fileList.length > 0 ? (
            <ul className="text-[14px] text-[#02256d] mt-2">
              {fileList.map((file, index) => (
                <li key={index} className="font-bold">{file.name}</li>
              ))}
            </ul>
          ) : (
            <p className="font-bold text-[14px]">Drag and Drop or <span className="text-[#02256d]">click to upload</span></p>
          )}
        </div>
      </div>

      {/* Thumbnail Upload */}
      <div>
        <label className="text-[#030303] font-medium">Add Thumbnail</label>
        <div className="mt-1 w-full h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
          <RiGalleryUploadLine
            size={24}
            className="text-[30px] cursor-pointer"
            onClick={() => document.getElementById("file-upload")?.click()}
          />
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            name="image"
            className="hidden"
            onChange={handleFileChange}
          />
          {fileName ? (
            <p className="text-[14px] text-[#02256d] mt-2">
              Selected file: <span className="font-bold">{fileName}</span>
            </p>
          ) : (
            <p className="font-bold text-[14px]">Drag and Drop or <span className="text-[#02256d]">click to upload</span></p>
          )}
        </div>
      </div>

      {/* Error */}
      {error && <p className="text-red-500">{error}</p>}

      <div className='flex justify-between'>
        {/* Date */}
        <div className='flex flex-col'>
          <label htmlFor="date" className="text-[#030303] font-medium">Date</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="mt-1 w-[150px] bg-transparent placeholder-[#94A2B8] outline-none border border-[#94A2B8] rounded-md p-1 text-[14px]"
            required
          />
        </div>

        <div className='flex items-center'>
          {/* Cancel */}
          <button
            type="button"
            onClick={onClose}
            className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold"
          >
            Cancel
          </button>

          {/* Submit */}
          <button
            type="submit"
            className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px] font-semibold"
            disabled={!formData.title || !formData.content || !formData.date}
          >
            {postId ? 'Update Post' : 'Create Post'}
          </button>
        </div>
      </div>
    </form>
      </div>
    </div>
  );
};

interface NewsProps {
  onCloseNewsPop: () => void;
}

const ModalNews: React.FC<NewsProps> = ({ onCloseNewsPop }) => {
  const [formData, setFormData] = useState({ title: "" });
  const api = process.env.REACT_APP_API_URL as string;
  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/newsheading`);
        //console.log("Fetched news heading data:", response.data);
        
        if (response.data && response.data.data && response.data.data.length > 0) {

          setFormData({ title: response.data.data[0].title });
        }
      } catch (error) {
        console.error("Failed to fetch news heading:", error);
      }
    };

    fetchData();
  }, []);

  //console.log("form data title", formData.title);
  // Handle input change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.title) {
      alert("Please enter a title");
      return;
    }

    try {
      //console.log("Updating news heading:", formData.title);
      await axios.put(
        `${api}/auth/newsheading`,
        { title: formData.title },
        { headers: { "Content-Type": "application/json" } }
      );

      //console.log("News heading updated successfully");
      window.location.reload(); // Reload page to reflect changes
    } catch (error) {
      console.error("Failed to update news heading:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg p-6 rounded shadow-md relative">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Title Input */}
          <div>
            <label htmlFor="title" className="text-gray-800 font-medium">
              Post Title
            </label>
            <div className="mt-2 w-full h-12 border px-3 border-gray-300 rounded-lg flex items-center">
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Write your post title here..."
                className="w-full bg-transparent placeholder-gray-400 outline-none text-sm"
                required
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onCloseNewsPop}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-yellow-500 text-white rounded-md text-sm hover:bg-yellow-600"
            >
              Update News Heading
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default News